import { render } from "./DevChat.vue?vue&type=template&id=0cd30918&scoped=true&ts=true"
import script from "./DevChat.vue?vue&type=script&lang=ts"
export * from "./DevChat.vue?vue&type=script&lang=ts"

import "./DevChat.vue?vue&type=style&index=0&id=0cd30918&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd30918"]])

export default __exports__